<template>
  <div class="box-list">
    <div v-for="category in boxCategory"
         :key="category.name"
         class="box-list__item"
         :class="{'box-list__item--active' : category.quantity >  category.min}"
    >
      <div class="box-list__item__icon" :style="getBoxImage(category.icon)"/>
      <div class="box-list__item__label">{{ category.name }}</div>
      <div class="box-list__item__size"> {{ category.size }}</div>
      <div class="box-list__item__counter"
           :class="{'box-list__item__counter--active' : category.quantity >  category.min}">
        <div class="box-list__item__counter__button minus"
             :class="{disabled: category.quantity - category.step < category.min}"
             @click="()=>{decrease(category)}"> - </div>
        <span class="box-list__item__counter__value"
              :class="{'box-list__item__counter__value--active':category.quantity > category.min}">
          {{ category.quantity }}
        </span>
        <div class="box-list__item__counter__button plus"
             @click="()=>{increase(category)}"
             :class="{disabled: category.quantity + category.step > category.max}"
        > + </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: 'box-list',
  props: {
    value: {
      type: Array,
    },
  },
  computed: {
    boxCategory: {
      get() {
        return this.value.filter(category => !category.hide);
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    increase(category) {
      if (category.quantity + category.step <= category.max) category.quantity += category.step;
    },
    decrease(category) {
      if (category.quantity - category.step >= category.min) category.quantity -= category.step;
    },
    getBoxImage(icon) {
      // eslint-disable-next-line
      const imageUrl = require(`@/assets/img/${icon}.png`);
      return {
        backgroundImage: `url('${imageUrl}')`,
      };
    },
  },
};
</script>
<style src="@/assets/scss/furnitures.scss" lang="scss" scoped/>

<style scoped lang="scss">
.box-list {
  @include breakpoint(tablet){
    display: flex;
    flex-direction: row;
    margin: 0 -15px;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border: 1px solid $--color-secondary;
    border-radius: $--border-radius-base;
    margin: 8px 0;

    &--active{
      border-color: $--color-primary;
      background-color: rgba(28, 219, 161, 0.1);
    }
    @include breakpoint(tablet){
      flex-direction: column;
      width: 140px;
      font-size: 14px;
      padding: 0;
      font-weight: bold;
      margin: 8px 15px;
    }
    &__icon{
      display: none;
      margin: 4px 0;
      width: 54px;
      height: 80px;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: contain;
      @include breakpoint(tablet){
        display: unset;
      }
    }
    &__label {
      font-size: 14px;
      text-align: center;
      &--active{
        font-weight: $--font-weight-600;
      }
    }
    &__size {
      display: none;
      @include breakpoint(tablet){
        display: unset;
        padding-bottom: 14px;
      }
    }
    &__counter {
      display: grid;
      grid-template-columns: 33% 33% 33%;
      align-items: center;
      color: #737A99;
      width: 75px;
      text-align: center;
      font-size: $--font-size-tiny;
      @include breakpoint(tablet){
        border-top: 1px solid $--color-secondary;
        width: 100%;
        height: 36px;
      }
      &--active{
        border-color: $--color-primary;
      }
      &__value {
        border: none;
        @include breakpoint(tablet){
          display: grid;
          place-content: center;
          align-items: center;
          width: 100%;
          height: 36px;
          border-left: 1px solid $--color-secondary;
          border-right: 1px solid $--color-secondary;
        }
        &--active{
          border-color: $--color-primary;
          color: $--color-secondary;
          font-weight: 600;
        }
      }

      &__button {
        display: grid;
        place-content: center;
        align-items: center;
        font-size: 25px;
        line-height: 30px;
        width: 100%;
        height: 100%;
        &:not(.disabled) {
          cursor: pointer;
        }
        &.minus {
          margin-bottom: 4px;
        }
      }
    }
  }
}
.disabled{
  cursor: not-allowed;
}
</style>
